var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrap9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-14.515 28.325l43.84-43.84 2.829 2.828-43.84 43.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93CF4A",
    d: "M-11.687 31.153l43.84-43.84 2.829 2.828-43.84 43.84zm5.657 5.657L37.812-7.03l2.829 2.828L-3.2 39.638zm5.657 5.657l43.84-43.84 2.829 2.828-43.84 43.84zm5.657 5.657l43.84-43.84 2.829 2.828-43.84 43.84zm5.657 5.658l43.84-43.84 2.83 2.828L13.77 56.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-8.857 33.982l43.84-43.84 2.829 2.827-43.84 43.841zm5.657 5.657l43.84-43.84 2.828 2.828-43.84 43.84zm5.656 5.657l43.84-43.84 2.829 2.828-43.84 43.84zm5.656 5.658l43.841-43.84 2.828 2.828-43.84 43.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93CF4A",
    d: "M-17.343 25.497l43.841-43.84 2.828 2.828-43.84 43.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-20.172 22.669l43.841-43.84 2.828 2.828-43.84 43.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93CF4A",
    d: "M-23 19.84L20.84-24l2.83 2.829-43.841 43.84z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.1 19.701h.136c.63 0 1.153-.082 1.573-.246.423-.168.76-.401 1.011-.697.251-.296.431-.645.54-1.046.11-.401.164-.836.164-1.306V14.69c0-.405-.043-.76-.13-1.066a2.18 2.18 0 00-.355-.772 1.512 1.512 0 00-.526-.472 1.327 1.327 0 00-.636-.157c-.25 0-.476.057-.677.17a1.49 1.49 0 00-.499.459 2.252 2.252 0 00-.307.676 3.159 3.159 0 00-.103.82c0 .274.032.538.096.794.068.25.168.474.3.67.133.196.299.35.5.464.2.114.435.171.704.171.255 0 .49-.048.704-.143a1.927 1.927 0 00.936-.971c.091-.21.142-.424.15-.643l.63.192c0 .346-.073.688-.22 1.025-.14.333-.339.638-.594.916-.25.274-.544.492-.882.657a2.423 2.423 0 01-1.087.246c-.474 0-.893-.09-1.258-.267a2.64 2.64 0 01-.902-.738 3.256 3.256 0 01-.533-1.067 4.44 4.44 0 01-.178-1.264c0-.479.073-.928.219-1.347.146-.42.358-.788.636-1.107a2.858 2.858 0 011.011-.752 3.252 3.252 0 011.36-.274c.539 0 1.01.105 1.416.315.405.21.747.499 1.025.868.278.369.488.797.63 1.285.14.488.211 1.012.211 1.572v.581c0 .588-.052 1.155-.157 1.702a5.68 5.68 0 01-.513 1.511c-.232.46-.54.866-.923 1.217a4.035 4.035 0 01-1.394.813c-.547.192-1.19.287-1.928.287h-.15v-1.36z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
SvgTrap9.displayName = 'Trap9';
export default SvgTrap9;